import { FoodFactCreate } from './../../../core/model/api-response/persoanl-response-model';
import {
  FoodModel,
  FoodFactModel,
  FoodFactsModel,
} from './../../../core/model/object/diet-food-model';
import {
  FoodLogModel,
  DietDayFoodLogsModel,
} from './../../../core/model/object/foodlog-model';
import { Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { LogoutService } from '../user-repository/logout.service';

@Injectable({
  providedIn: 'root',
})
export class FoodLogDataService {
  constructor(
    private dbService: NgxIndexedDBService,
    private logoutService: LogoutService
  ) {}
  makeFoodFactsModel(f: FoodFactCreate): FoodFactsModel {
    const calorie = new FoodFactModel('calorie', f.calorieAmount);
    const protein = new FoodFactModel('protein', f.proteinAmount);
    const fat = new FoodFactModel('fat', f.fatAmount);
    const carbohydrat = new FoodFactModel('carbohydrate', f.carbohydrateAmount);
    const sugar = new FoodFactModel('sugar', f.sugarAmount);
    const fiber = new FoodFactModel('fiber', f.fiberAmount);
    const sodium = new FoodFactModel('sodium', f.sodiumAmount);
    const potassium = new FoodFactModel('potassium', f.potassiumAmount);
    const calcium = new FoodFactModel('calcium', f.calciumAmount);
    const magnesium = new FoodFactModel('magnesium', f.magnesiumAmount);
    const iron = new FoodFactModel('iron', f.ironAmount);
    const cholesterol = new FoodFactModel('cholesterol', f.cholesterolAmount);
    const phosphor = new FoodFactModel('phosphor', f.phosphorAmount);
    const saturatedFat = new FoodFactModel(
      'saturatedFat',
      f.saturatedFatAmount
    );
    const polyunsaturatedFat = new FoodFactModel(
      'polyunsaturatedFat',
      f.polyunsaturatedFatAmount
    );
    const transFat = new FoodFactModel('transFat', f.transFatAmount);
    const monounsaturatedFat = new FoodFactModel(
      'monounsaturatedFat',
      f.monounsaturatedFatAmount
    );
    return new FoodFactsModel(
      calorie,
      protein,
      fat,
      carbohydrat,
      sugar,
      fiber,
      sodium,
      potassium,
      calcium,
      magnesium,
      iron,
      cholesterol,
      phosphor,
      saturatedFat,
      polyunsaturatedFat,
      transFat,
      monounsaturatedFat
    );
  }
  public async getDayFoodLogs(date: number): Promise<DietDayFoodLogsModel> {
    let foodLogs: FoodLogModel[] = [];
    let dietdayFoodLogModel: DietDayFoodLogsModel;
    const response = await this.dbService
      .getByIndex('foodLogs', 'date', date)
      .then(
        async (fls) => {
          if (fls) {
            foodLogs = [];
            fls['foodLogs'].forEach((fl, i) => {
              if (fl.calorie && fl.title) {
                const foodModel = new FoodModel(
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  this.makeFoodFactsModel(
                    new FoodFactCreate(
                      fl.calorie,
                      -1,
                      -1,
                      -1,
                      -1,
                      -1,
                      -1,
                      -1,
                      -1,
                      -1,
                      -1,
                      -1,
                      -1,
                      -1,
                      -1,
                      -1,
                      -1
                    )
                  )
                );
                const f = new FoodLogModel(
                  fl['amount'],
                  fl['date'],
                  fl['food'],
                  fl['meal'],
                  fl['unit'],
                  fl['user'],
                  foodModel,
                  fl['_id'],
                  fl['calorie'],
                  fl['title']
                );
                foodLogs.push(f);
              } else {
                const f = new FoodLogModel(
                  fl['amount'],
                  fl['date'],
                  fl['food'],
                  fl['meal'],
                  fl['unit'],
                  fl['user'],
                  null,
                  fl['_id'],
                  fl['calorie'],
                  fl['title']
                );
                foodLogs.push(f);
              }
            });
            const foodLogsUpdatedAt = fls['updatedAt'];
            dietdayFoodLogModel = new DietDayFoodLogsModel(
              foodLogs,
              date,
              foodLogsUpdatedAt
            );
          } else {
            dietdayFoodLogModel = null;
          }
          return dietdayFoodLogModel;
        },
        (error) => {
          console.log(error);
          this.logoutService.logout();
          return new DietDayFoodLogsModel(null, null, null);
        }
      );
    return Promise.resolve(response);
  }

  public async saveFoodLogs(
    res: FoodLogModel[],
    date: number
  ): Promise<boolean> {
    const fls = await this.dbService.getByIndex('foodLogs', 'date', date);
    let response = true;
    if (fls) {
      response = await this.dbService
        .update('foodLogs', {
          id: fls['id'],
          foodLogs: res ? res : fls['foodLogs'],
          date,
          updatedAt: new Date().getTime(),
        })
        .then(
          () => {
            return true;
          },
          (error) => {
            console.log(error);
            return false;
          }
        );
    } else {
      response = await this.dbService
        .add('foodLogs', {
          foodLogs: res,
          date,
          updatedAt: new Date().getTime(),
        })
        .then(
          () => {
            return true;
          },
          (error) => {
            console.log(error);
            return false;
          }
        );
    }
    return Promise.resolve(response);
  }

  public async updateFoodLogs(
    res: FoodLogModel[],
    date: number
  ): Promise<boolean> {
    let response = true;
    const fls = await this.dbService.getByIndex('foodLogs', 'date', date);
    if (fls) {
      res.forEach((foodlog) => {
        let found = false;
        fls['foodLogs'].forEach((f, i) => {
          if (foodlog._id === f._id) {
            found = true;
            fls['foodLogs'][i] = foodlog;
          }
        });
        if (!found) {
          fls['foodLogs'].push(foodlog);
        }
      });
      response = await this.dbService
        .update('foodLogs', {
          id: fls['id'],
          foodLogs: fls['foodLogs'],
          date,
          updatedAt: new Date().getTime() + 1000,
        })
        .then(
          () => {
            return true;
          },
          (error) => {
            console.log(error);
            return false;
          }
        );
    } else {
      response = await this.dbService
        .add('foodLogs', {
          foodLogs: res,
          date,
          updatedAt: new Date().getTime() + 1000,
        })
        .then(
          () => {
            return true;
          },
          (error) => {
            console.log(error);
            return false;
          }
        );
    }
    return Promise.resolve(response);
  }

  public async removeFoodLogs(
    date: number,
    foodLogs: string[]
  ): Promise<boolean> {
    let response = true;
    let updated = false;
    const fls = await this.dbService.getByIndex('foodLogs', 'date', date);
    foodLogs.forEach((foodLog) => {
      fls['foodLogs'].forEach((f, i) => {
        if (foodLog === f._id) {
          updated = true;
          fls['foodLogs'].splice(i, 1);
        }
      });
    });
    response = await this.dbService
      .update('foodLogs', {
        id: fls['id'],
        foodLogs: fls['foodLogs'],
        date,
        updatedAt: new Date().getTime(),
      })
      .then(
        () => {
          return updated;
        },
        (error) => {
          console.log(error);
          return false;
        }
      );
    return Promise.resolve(response);
  }
}
